import { useEffect, useMemo, useState } from "react";
import { ensurePathExists, insertChildrenAtPath } from "../components/dataBrowse/utils";
import { FileSystemItem } from "../components/dataBrowse/types";

type UseFileSystemTreeArgs = {
  currentPath: string[];
  currentCruiseId?: string;
  folderItems: FileSystemItem[];
  hasFolderData: boolean;
};

const useFileSystemTree = ({
  currentPath,
  folderItems,
  hasFolderData,
}: UseFileSystemTreeArgs) => {
  const [fileSystemTree, setFileSystemTree] = useState<FileSystemItem>({
    name: "root",
    path: "",
    type: "folder",
    children: [],
  });

  const currentFolder = useMemo(() => {
    let folder = fileSystemTree;
    for (const pathPart of currentPath) {
      folder =
        folder.children?.find((child) => child.name === pathPart) ||
        fileSystemTree;
    }
    return folder;
  }, [currentPath, fileSystemTree]);

  useEffect(() => {
    if (currentPath.length < 2) return;
    if (!hasFolderData) return;
    setFileSystemTree((prev) => {
      const withPath = ensurePathExists(prev, currentPath);
      return insertChildrenAtPath(withPath, currentPath, folderItems);
    });
  }, [currentPath, folderItems, hasFolderData]);

  return { fileSystemTree, setFileSystemTree, currentFolder };
};

export default useFileSystemTree;
